import Link from "next/link";

import Button from "../button";
import SolutionListItem from "../solution-list-item";

import styles from "./other-solutions.module.scss";

const OtherSolutions = ({ solutions }) => {
  return (
    <div className={styles.OtherSolutions}>
      <h3>Other solutions</h3>

      <div className={styles.SolutionsList}>
        {solutions.map((solution) => (
          <SolutionListItem key={solution.name} solution={solution} />
        ))}
      </div>

      <div className={styles.ViewAll}>
        <Link href="/solutions" passHref>
          <Button rounded outline small>
            View All Solutions
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default OtherSolutions;
